module.exports = __webpack_public_path__ + "static/img/banner1.73ee750.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner1.jpg
// module id = nTyu
// module chunks = 1